import { ConditionPrelevementLac } from "../Lac - EAU/condition-prelevement-lac";
import { Substrat } from "./substrat";

export class IMLProcess {
    Code: string;

    ConditionPrelevement: ConditionPrelevementLac = new ConditionPrelevementLac();
    IMLSubstratList: Substrat[] = [];

    static mapFromJSON(json: any): IMLProcess {
        const IML = new IMLProcess();

        IML.Code = json.code;

        if (json.conditionPrelevement) {
            IML.ConditionPrelevement = ConditionPrelevementLac.mapFromJSON(json.conditionPrelevement);
        }

        if (json.imlSubstratList) {
            IML.IMLSubstratList = json.imlSubstratList.map(jsonItem => Substrat.mapFromJSON(jsonItem));
        }
        return IML;
    }
}